import { shallowMount } from '@vue/test-utils';
import { createPinia, setActivePinia, defineStore } from 'pinia';
import { vi } from 'vitest';
import { ref } from 'vue';

import { ORDER_ITEM } from '~/support/fixtures';

import Component from './ItemIssueDetailModalSelectCount.vue';

let wrapper;
let vm;
let pinia;

describe('ItemIssueDetailModalSelectCount', () => {
  beforeEach(() => {
    pinia = createPinia();
    setActivePinia(pinia);

    // Define and set up the orders store
    const useOrdersStore = defineStore('orders', () => {
      const currentOrder = ref({
        existingClaims: [],
        fulfillments: [],
        settings: {
          credit: {
            bonus: null,
            bonusType: null,
          },
          returns: {
            portalUrl: '',
            trackingUrl: '',
          },
        },
      });

      const getClaimedQuantity = vi.fn().mockReturnValue(0);

      return {
        currentOrder,
        getClaimedQuantity,
      };
    });

    // Create the store instance
    useOrdersStore(pinia);

    wrapper = shallowMount(Component, {
      props: {
        item: ORDER_ITEM,
      },
    });

    vm = wrapper.vm;
  });

  describe('methods', () => {
    describe('handleContinueClick', () => {
      test('invalid', () => {
        vm.$v.$touch = vi.fn();

        vm.handleContinueClick();
        expect(vm.$v.$touch).toHaveBeenCalled();
        expect(vm.$v.$invalid).toBeTruthy();
      });

      test('valid', async () => {
        await wrapper.find('[data-hubble="1-items-with-issues"]').trigger('click');

        await vm.handleContinueClick();
        expect(wrapper.emitted('continue')).toHaveLength(1);
      });
    });
  });
});
